import React, { useState } from "react";
import Badge from "@mui/material/Badge";
import { styled } from "@mui/material/styles";
import MuiTheme from "./MuiTheme";

// import JS files

const CustomBadge = styled(Badge)({
  "& .MuiBadge-badge": {
    backgroundColor: "#facc15",
    color: "#000",
  },
});

// import Others files
const MuiBadge = ({ children, count }) => {
  let windowWidth = window.screen.width;

  return (
    <>
      <MuiTheme>
        <CustomBadge
          badgeContent={count}
          showZero
          color="secondary"
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          {children}
        </CustomBadge>
      </MuiTheme>
    </>
  );
};

export default MuiBadge;
